import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-wrench-icon',
  templateUrl: 'wrench-icon.component.html'
})
export class WrenchIconComponent {
  constructor() {}
}
